var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_15)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49995 9.438V8.5H6.49995V9.438C6.49995 9.51992 6.51003 9.60153 6.52995 9.681L6.92995 11.279L5.99995 11.899L5.06995 11.279L5.46995 9.681C5.48986 9.60153 5.49994 9.51992 5.49995 9.438V9.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.293 0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H12C12.5304 16 13.0391 15.7893 13.4142 15.4142C13.7893 15.0391 14 14.5304 14 14V4.707C13.9999 4.4418 13.8945 4.18749 13.707 4L10 0.293C9.81251 0.105451 9.5582 5.66374e-05 9.293 0V0ZM9.5 3.5V1.5L12.5 4.5H10.5C10.2348 4.5 9.98043 4.39464 9.79289 4.20711C9.60536 4.01957 9.5 3.76522 9.5 3.5ZM5.5 3V2H4.5V1H6V2H7V3H6V4H7V5H6V6H7V7H5.5V6H4.5V5H5.5V4H4.5V3H5.5ZM5.5 7.5H6.5C6.76522 7.5 7.01957 7.60536 7.20711 7.79289C7.39464 7.98043 7.5 8.23478 7.5 8.5V9.438L7.9 11.037C7.94984 11.2371 7.93661 11.4476 7.86215 11.6399C7.78768 11.8322 7.6556 11.9967 7.484 12.111L6.554 12.731C6.38977 12.8404 6.19684 12.8988 5.9995 12.8988C5.80216 12.8988 5.60923 12.8404 5.445 12.731L4.515 12.111C4.34358 11.9966 4.21171 11.832 4.13742 11.6397C4.06313 11.4475 4.05006 11.237 4.1 11.037L4.5 9.438V8.5C4.5 8.23478 4.60536 7.98043 4.79289 7.79289C4.98043 7.60536 5.23478 7.5 5.5 7.5V7.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.e945b79199dc7459bdfb047ec54ce566.svg";
export { ForwardRef as ReactComponent };